import { createFileRoute } from '@tanstack/react-router'
import { orderListSearchSchema, ServiceOrderList } from '@/features/order/index.ts'
import { usePersistedListQuery } from '@/hooks/use-persisted-list-query.ts'
import { createListQueryPersistence } from '@/utils/list-query-persistence.ts'

const listQuery = createListQueryPersistence('super-mega:orders:service:list-query', orderListSearchSchema)

export const Route = createFileRoute('/_authenticated/orders/service/')({
  beforeLoad: (options) => {
    listQuery.restore(options)
  },
  component: OrdersPage,
  head: () => ({ meta: [{ title: '服务订单 · Super Mega' }] }),
  validateSearch: listQuery.validateSearch
})
function OrdersPage() {
  const { currentSession } = Route.useRouteContext()
  const { search, navigateSearch } = usePersistedListQuery({
    persistence: listQuery,
    raw: Route.useSearch(),
    accountId: currentSession.id,
    navigate: Route.useNavigate()
  })
  return <ServiceOrderList search={search} navigateSearch={navigateSearch} currentSession={currentSession} />
}
